const StopServiceIcon = () => {
  return <img src="/icons/stop.svg" alt="stop-service" />;
};

export default StopServiceIcon;
